import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/pages/admin/AdminLayout";
import { MessageCircle } from "lucide-react";

const LABELS = {
  order_confirmation: "Order Confirmation", tradein_request: "Trade-In Request",
  pickup_confirmation: "Pickup Confirmation", collection: "Collection", points_credit: "Points Credit",
  balance: "Balance", redemption: "Redemption", tradein_rejected: "Rejected Trade-In",
};

export default function AdminWhatsApp() {
  const [events, setEvents] = useState([]);
  const [live, setLive] = useState(false);
  useEffect(() => {
    api.get("/admin/whatsapp-events").then(({ data }) => {
      setEvents(data);
      setLive(data.some((e) => e.provider === "twilio"));
    });
  }, []);

  return (
    <AdminLayout title="WhatsApp Events">
      {live ? (
        <div className="bg-[hsl(var(--secondary))]/10 border border-[hsl(var(--secondary))]/20 rounded-lg p-4 mb-4 text-sm flex items-start gap-2">
          <MessageCircle className="text-[hsl(var(--secondary))] shrink-0" size={18} />
          <div><b>Live via Twilio.</b> Messages are delivered to each customer's WhatsApp number on real backend events. Check the delivery status on each event below.</div>
        </div>
      ) : (
        <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4 text-sm flex items-start gap-2">
          <MessageCircle className="text-primary shrink-0" size={18} />
          <div>Twilio credentials not set — running in <b>mock mode</b>. Add <code>TWILIO_ACCOUNT_SID</code>, <code>TWILIO_AUTH_TOKEN</code> and <code>TWILIO_WHATSAPP_FROM</code> to the backend to deliver these messages live. Templates and triggers are already wired.</div>
        </div>
      )}
      <div className="space-y-2">
        {events.length === 0 && <div className="text-muted-foreground text-center py-10 bg-card border border-border rounded-lg">No events yet.</div>}
        {events.map((e) => (
          <div key={e.event_id} className="bg-card border border-border rounded-lg p-3 flex items-start gap-3" data-testid={`wa-event-${e.event_id}`}>
            <span className="grid place-items-center w-9 h-9 rounded-full bg-[hsl(var(--secondary))] text-white shrink-0"><MessageCircle size={16} /></span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs font-semibold px-2 py-0.5 rounded bg-muted">{LABELS[e.event_type] || e.event_type}</span>
                <span className="text-xs text-muted-foreground">{e.phone || "no phone"}</span>
                <span className="text-xs text-muted-foreground ml-auto">{e.created_at?.slice(0, 16).replace("T", " ")}</span>
              </div>
              <div className="text-sm mt-1">{e.message}</div>
              {e.error && <div className="text-xs text-destructive mt-1">Delivery error: {e.error}</div>}
              {e.message_sid && <div className="text-[10px] text-muted-foreground mt-0.5 font-mono-points">SID {e.message_sid}</div>}
            </div>
            <span className={`text-[10px] uppercase font-semibold ${e.status === "failed" ? "text-destructive" : e.provider === "twilio" ? "text-[hsl(var(--secondary))]" : "text-primary"}`}>{e.status}</span>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
